import resetForm from './resetForm';
import setIsNewRecord from './setIsNewRecord';
import toggleProductForm from './toggleProductForm';

export default () => (dispatch) => {
    dispatch(resetForm());
    dispatch(setIsNewRecord(true));
    dispatch(toggleProductForm(true));
};
